// @ts-check
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import {
  enumData,
  enumPage,
  enumPagination,
  enumRoutes,
  enumSharedMsgs,
  enumSQLS,
  enumTaskPhase,
  enumTaskType
} from "../../helpers/common.constants";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid
} from "@mui/material";
import Link from "@mui/material/Link";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MessageHelper } from "../../helpers/MessageHelper";
import FinTimeActions from "../../actions/FinTimeActions";
import TaskActions from "../../actions/TaskActions";
import MyAlert from "../../controls/MyAlert";
import MyDate from "../../controls/MyDate";
import MyAutoSuggest from "../../controls/MyAutoSuggest";
import MyText from "../../controls/MyText";
import moment from "moment";
import MyDropDown from "../../controls/MyDropDown";
import DocumentActions from "../../actions/DocumentActions";
import MyDocumentPicker from "../../controls/MyDocumentPicker";

const RecordDefault = {
  // Main task properties
  CheckLists:[],
  mtTaskID: 0,
  mtTaskTemplateID: 0,
  mtEntityID: 0,
  mtEntityRowID: 0,
  mtActiveFL: false,
  mtTaskTypeID: 0,
  mtTaskFlowVerifierID: 0,
  mtTaskFlowApprovalID: 0,
  mtTaskName: "",
  mtTaskNote: "",
  mtTaskCreatedDate: moment().format("YYYY-MM-DD"),
  mtTaskDueDate: moment().format("YYYY-MM-DD"),
  mtTaskVerifierDueDate: moment().format("YYYY-MM-DD"),
  mtTaskTotalVerifiers: 0,
  mtTaskApporverDueDate: moment().format("YYYY-MM-DD"),
  mtTaskTotalApprovers: 0,
  mtTaskTotalPhases: 0,
  mtTaskCurrentPhase: 0,
  mtCreatorFL: false,
  mtCreatorStaffID: 0,
  mtCreatorFullName: "",
  mtCreatorEmail: "",
  mtCreatorGoogleDocFileID1: "",
  mtCreatorGoogleDocName1: "",
  mtCreatorGoogleDocFileID2: "",
  mtCreatorGoogleDocName2: "",
  mtGoogleFolderID: "",
  mtTaskMandatoryTotalFiles: 0,
  mtTaskMandatoryFileCaption1: "",
  mtTaskMandatoryGoogleDocFileID1: "",
  mtTaskMandatoryGoogleDocName1: "",
  mtTaskMandatoryFileCaption2: "",
  mtTaskMandatoryGoogleDocFileID2: "",
  mtTaskMandatoryGoogleDocName2: "",
  mtTaskOptionalTotalFiles: 0,
  mtTaskOptionalFileCaption1: "",
  mtTaskOptionalGoogleDocFileID1: "",
  mtTaskOptionalGoogleDocName1: "",
  mtTaskOptionalFileCaption2: "",
  mtTaskOptionalGoogleDocFileID2: "",
  mtTaskOptionalGoogleDocName2: "",

  // Verifier 1–4
  mtnVerifierID1: 0,
  mtnVerifierName1: "",
  mtnVerifierEmail1: "",
  mtnVerifierNote1: "",
  mtnVerifierApprovedFL1: null,
  mtnVerifierDate1: null,
  mtnVerifierCaption1: "",

  mtnVerifierID2: 0,
  mtnVerifierName2: "",
  mtnVerifierEmail2: "",
  mtnVerifierNote2: "",
  mtnVerifierApprovedFL2: null,
  mtnVerifierDate2: null,
  mtnVerifierCaption2: "",

  mtnVerifierID3: 0,
  mtnVerifierName3: "",
  mtnVerifierEmail3: "",
  mtnVerifierNote3: "",
  mtnVerifierApprovedFL3: null,
  mtnVerifierDate3: null,
  mtnVerifierCaption3: "",

  mtnVerifierID4: 0,
  mtnVerifierName4: "",
  mtnVerifierEmail4: "",
  mtnVerifierNote4: "",
  mtnVerifierApprovedFL4: null,
  mtnVerifierDate4: null,
  mtnVerifierCaption4: "",

  // Approver 1–4
  mtnApproverID1: 0,
  mtnApproverName1: "",
  mtnApproverEmail1: "",
  mtnApproverNote1: "",
  mtnApproverApprovedFL1: null,
  mtnApproverDate1: null,
  mtnApproverCaption1: "",

  mtnApproverID2: 0,
  mtnApproverName2: "",
  mtnApproverEmail2: "",
  mtnApproverNote2: "",
  mtnApproverApprovedFL2: null,
  mtnApproverDate2: null,
  mtnApproverCaption2: "",

  mtnApproverID3: 0,
  mtnApproverName3: "",
  mtnApproverEmail3: "",
  mtnApproverNote3: "",
  mtnApproverApprovedFL3: null,
  mtnApproverDate3: null,
  mtnApproverCaption3: "",

  mtnApproverID4: 0,
  mtnApproverName4: "",
  mtnApproverEmail4: "",
  mtnApproverNote4: "",
  mtnApproverApprovedFL4: null,
  mtnApproverDate4: null,
  mtnApproverCaption4: "",
  TaskFlowVerifierTitle:  "",
  TaskFlowApproverTitle:  "",
}





const styles = {
  TDSmall: { mt: 0, mb: 0, pt: 0, pb: 0 },
};

export default function TaskManage() {
  const [Record, setRecord] = useState(RecordDefault);
  const [MessageData, setMessageData] = useState({});
  const [FileData, setFileData] = useState(null);
  const [FileData2, setFileData2] = useState(null);
  const [MsgErrorFileData, setMsgErrorFileData] = useState("");
  const [MsgErrorFileData2, setMsgErrorFileData2] = useState("");
  const { TaskID, showMsg } = useParams();

  //Za Refreshiranje na strana mu treba;
  const location = useLocation();

  //za poraki pri loadiranje na strana
  const msgHelper = new MessageHelper();

  //za Navigacija
  const navigate = useNavigate();



  //****************************************** */
  //HOOKS SECTION HERE
  //****************************************** */

  //1 --> Ke se povika ovoj HOOK samo dokolku se SMENI url-ot poradi toa na new dodavame Ticks() za da forcirame refresh na strana na sekoj click
  useEffect(() => {
    initData();
  }, [location.pathname + "/" + location.search]);


  //****************************************** */
  //METHOD  SECTION HERE
  //****************************************** */
  const initData = () => {
    async function fetchData() {


      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      let payload = { mtTaskID: TaskID };

      let responses = await new TaskActions().EditAsync(payload); // await LookupActions.InitAsync();

      if (!responses.error) {
        let taskData = responses[0].data;

        if (taskData.mtTaskCurrentPhase !== enumTaskPhase.Initial) {
          result = msgHelper.setPhase(enumPage.LoadSuccessWithWarningMsg, null, "Task is locked for editing, current status:" + taskData.Status);
          setMessageData(result);
        }
        else {
          result = msgHelper.setPhase(enumPage.LoadSuccess);
          setMessageData(result);
        }

        setRecord(taskData);
      } else {
        //Load with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
      }
    }
    fetchData();
  };

  async function validateData() {

    //Load Start
    let result = msgHelper.setPhase(enumPage.LoadStart);
    setMessageData(result);

    //prvo validacija pred se 
    let responseValidate = await new TaskActions().ValidateAsync(Record);
    if (!responseValidate.error) {
      let recordDb = responseValidate[0].data;
      if (recordDb.length > 0) {

        setRecord((a) => ({
          ...a,
          ValidationMessages: recordDb,
        }));
        return false;
      }
    }
    return true;
  }

  const saveData = () => {
    async function fetchData() {

      //Napravi validacija
      let isOk = await validateData();
      if (!isOk) {
        //Finished  with Error
        let result = msgHelper.setPhase(enumPage.ErrorValidation, null, enumSharedMsgs.SaveClientError);
        setMessageData(result);
        return;
      }

      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      let responses = await new TaskActions().SaveAsync(Record);

      if (!responses.error) {

        let recordDb = responses[0].data;
          setRecord(recordDb);
          result = msgHelper.setPhase(enumPage.SaveSuccess);
          setMessageData(result);
      }
      else {
        //Finished  with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);

        setRecord((a) => ({
          ...a,
          ValidationMessages: result.ValidationMessages,
        }));
      }
    }
    fetchData();

  }; 


  const submitData = () => {
    async function fetchData() {

      //Napravi validacija
      let isOk = await validateData();
      if (!isOk) {
        //Finished  with Error
        let result = msgHelper.setPhase(enumPage.ErrorValidation, null, enumSharedMsgs.SaveClientError);
        setMessageData(result);
        return;
      }

      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);
      let responses = await new TaskActions().SubmitAsync(Record);

      if (!responses.error) {
        let recordDb = responses[0].data;
        setRecord(recordDb);

        result = msgHelper.setPhase(enumPage.ActionSuccessWithMsg, null, "Task is submitted");
        setMessageData(result); 

      } else {
        //Finished  with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);

        setRecord((a) => ({
          ...a,
          ValidationMessages: result.ValidationMessages,
        }));
      }
    }

    fetchData();
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log(name + ":" + value);
    setRecord((prevState) => ({ ...prevState, [name]: value }));
  };


  // const downloadFile = (fileName, fileId) => {
  //   async function fetchData() {
  //     let payload = "/" + fileId;
  //     let response = await new DocumentActions().DownloadFileAsync(payload);

  //     // create file link in browser's memory
  //     const href = URL.createObjectURL(response.data);

  //     // create "a" HTML element with href to file & click
  //     const link = document.createElement("a");
  //     link.href = href;
  //     link.setAttribute("download", fileName); //or any other extension
  //     document.body.appendChild(link);
  //     link.click();

  //     // clean up "a" element & remove ObjectURL
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(href);
  //   }
  //   fetchData();
  // };

  return (
    <Typography sx={{ my: 5, mx: 2 }} color="text.secondary" align="left">

      <MyAlert {...MessageData} />

      <Card sx={{ minWidth: 275, borderRadius: 2, mb: 2 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Typography variant="h3" align="center">
                {Record.mtTaskName} {Record.mtTaskCurrentPhase > enumTaskPhase.Initial ? " (Status:" + Record.Status + ")" : ""}
              </Typography>
              <Typography variant="subtitle1" align="center">
                Type:{Record.TaskTypeTitle}  
                {Record.TaskFlowVerifierTitle !== "" ? " - Verifier Flow:" + Record.TaskFlowVerifierTitle : ""}
                {Record.TaskFlowApproverTitle !== "" ? " - Approver Flow:" + Record.TaskFlowApproverTitle : ""}
              </Typography>              
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Grid container padding={1}>
        <Grid item xs={6} align="left">
          <Button
            name="btnSubmit"
            variant="contained"
            sx={{ mr: 1 }}
            color="warning"
            size="small"
            disabled={MessageData.Loading || Record.IsLocked}
            onClick={() => submitData()}
          >
            Submit
          </Button>
        </Grid>

        <Grid item xs={6} align="right" >
          <Button
            name="btnSave"
            variant="contained"
            sx={{ mr: 1 }}
            color="success"
            size="small"
            disabled={MessageData.Loading || Record.IsLocked}
            onClick={() => saveData()}
          >
            Save
          </Button>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          <MyText
            Id="mtTaskName"
            PlaceHolder="Name"
            Record={Record}
            HandleChange={handleChange}
            ValidationMessages={Record.ValidationMessages}
            Required={true}
          />
        </Grid>
      </Grid>


    

      <Grid container>
        <Grid item xs={12}>
          <MyText
            Id="mtTaskNote"
            PlaceHolder="Description"
            Record={Record}
            HandleChange={handleChange}
            ValidationMessages={Record.ValidationMessages}
            Required={true}
            Rows={3}
            MultiLine={true}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          <MyAutoSuggest
            Id="mtCreatorStaffID"
            Record={Record}
            PlaceHolder="Responsible Person"
            HandleChange={handleChange}
            ValidationMessages={Record.ValidationMessages}
            Required={true}
            SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
            SQLGetRecord={enumSQLS.KEY_GET_Employee}
          />
        </Grid>
      </Grid>

      {/* <Grid container>
        <Grid item xs={12}>
          <MyDropDown
            Id="mtTaskTypeID"
            Record={Record}
            PlaceHolder="Task Type"
            HandleChange={handleChange}
            Options={enumData.TASKTYPES}
            Disabled={true}
          />
        </Grid>
      </Grid> */}


      {Record.mtTaskMandatoryTotalFiles >= 1 &&
        
        <Grid container align="left" sx={{ pt:2, pb: 2 }}>
          {/* <Grid item xs={12}>
            <Typography variant="h6">
              <b>Linked Documents</b>
            </Typography>
          </Grid> */}

        <Grid container>
              <Grid item xs={12}>
                <MyDocumentPicker
                  Id="mtTaskMandatoryGoogleDocFileID1"
                  PlaceHolder="Linked Documents"
                  Record={Record}
                  InputFolderID="1Qu_wrodNIxgj_kdZxu8YhZ12ecfx0ZII"
                  HandleChange={handleChange}
                  ValidationMessages={Record.ValidationMessages}
                  Required={true}
                />
              </Grid>
            </Grid>
        </Grid>
        //Proveri da ne treba uste eden fajl da se dodade za upload
      }

      {Record.CheckLists.length > 0 && 
      <Grid container>
        <Box
            sx={{
              border: '1px solid grey', // Adds a border like a groupbox
              borderRadius: 1, // Optional: adds rounded corners
              p: 2, // Adds padding inside the box
              mb: 2, // Adds margin-bottom for spacing if multiple groupboxes
              mt:2,
            }}
          >
        <Typography variant="h6" component="legend" sx={{ mb: 1 }}>
          {Record.mtTaskName} checklist:
        </Typography>
        {Record.CheckLists.map((item) => (
              <Grid item xs={12} key={item.mtcTaskCheckID}>
                <label style={{'fontSize':'10pt'}}>
                  <input  type="checkbox"  id={`check-${item.mtcTaskCheckID}`}  value={item.mtcTaskCheckID} />
                  {item.mtcDescription}
                </label>
              </Grid>
            ))}
      </Box>
      </Grid>
      }






      {(Record.mtTaskTypeID == enumTaskType.Verifier || Record.mtTaskTypeID == enumTaskType.VeriferAndApprover) && <Grid container>
        <Grid
          container
          align="left"
          sx={{ borderTop: 1, borderColor: "grey.500", mt: 2, pt: 2 }}
          align="center"
        >
          <Grid item xs={12}>
            <Typography variant="h5">Reviewers</Typography>
          </Grid>
        </Grid>


        {/* <Grid container>
          <Grid item xs={12}>
            <MyDropDown
              Id="mtTaskFlowVerifierID"
              Record={Record}
              PlaceHolder="Verification Task Flow"
              HandleChange={handleChange}
              Options={enumData.TASKFLOWS}
              Disabled={true}
            />
          </Grid>
        </Grid> */}

        <Grid container>
          <Grid item xs={12}>
            <MyDate
              Id="mtTaskVerifierDueDate"
              PlaceHolder="Review Due Date"
              Record={Record}
              HandleChange={handleChange}
              ValidationMessages={Record.ValidationMessages}
              Required={true}
            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <MyAutoSuggest
              Id="mtnVerifierID1"
              Record={Record}
              PlaceHolder={Record.mtnVerifierCaption1}
              HandleChange={handleChange}
              ValidationMessages={Record.ValidationMessages}
              Required={true}
              SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
              SQLGetRecord={enumSQLS.KEY_GET_Employee}
            />
          </Grid>
        </Grid>

        {Record.mtTaskTotalVerifiers >= 2 &&
          <Grid container>
            <Grid item xs={12}>
              <MyAutoSuggest
                Id="mtnVerifierID2"
                Record={Record}
                PlaceHolder={Record.mtnVerifierCaption2}
                HandleChange={handleChange}
                ValidationMessages={Record.ValidationMessages}
                Required={true}
                SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
                SQLGetRecord={enumSQLS.KEY_GET_Employee}
              />
            </Grid>
          </Grid>
        }

        {Record.mtTaskTotalVerifiers >= 3 &&
          <Grid container>
            <Grid item xs={12}>
              <MyAutoSuggest
                Id="mtnVerifierID3"
                Record={Record}
                PlaceHolder={Record.mtnVerifierCaption3}
                HandleChange={handleChange}
                ValidationMessages={Record.ValidationMessages}
                Required={true}
                SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
                SQLGetRecord={enumSQLS.KEY_GET_Employee}
              />
            </Grid>
          </Grid>
        }

        {Record.mtTaskTotalVerifiers == 4 &&
          <Grid container>
            <Grid item xs={12}>
              <MyAutoSuggest
                Id="mtnVerifierID4"
                Record={Record}
                PlaceHolder={Record.mtnVerifierCaption4}
                HandleChange={handleChange}
                ValidationMessages={Record.ValidationMessages}
                Required={true}
                SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
                SQLGetRecord={enumSQLS.KEY_GET_Employee}
              />
            </Grid>
          </Grid>
        }

      </Grid>
      }

      {(Record.mtTaskTypeID == enumTaskType.Approver || Record.mtTaskTypeID == enumTaskType.VeriferAndApprover) && <Grid container>
        <Grid
          container
          align="left"
          sx={{ borderTop: 1, borderColor: "grey.500", mt: 2, pt: 2 }}
          align="center"
        >
          <Grid item xs={12}>
            <Typography variant="h5">Approvers</Typography>
          </Grid>
        </Grid>

        {/* <Grid container>
          <Grid item xs={12}>
            <MyDropDown
              Id="mtTaskFlowApprovalID"
              Record={Record}
              PlaceHolder="Approval Task Flow"
              HandleChange={handleChange}
              Options={enumData.TASKFLOWS}
              Disabled={true}
            />
          </Grid>
        </Grid> */}


        <Grid container>
          <Grid item xs={12}>
            <MyDate
              Id="mtTaskApporverDueDate"
              PlaceHolder="Approver Due Date"
              Record={Record}
              HandleChange={handleChange}
              ValidationMessages={Record.ValidationMessages}
              Required={true}
            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <MyAutoSuggest
              Id="mtnApproverID1"
              Record={Record}
              PlaceHolder={Record.mtnApproverCaption1}
              HandleChange={handleChange}
              ValidationMessages={Record.ValidationMessages}
              Required={true}
              SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
              SQLGetRecord={enumSQLS.KEY_GET_Employee}
            />
          </Grid>
        </Grid>

        {Record.mtTaskTotalApprovers >= 2 &&
          <Grid container>
            <Grid item xs={12}>
              <MyAutoSuggest
                Id="mtnApproverID2"
                Record={Record}
                PlaceHolder={Record.mtnApproverCaption2}
                HandleChange={handleChange}
                ValidationMessages={Record.ValidationMessages}
                Required={true}
                SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
                SQLGetRecord={enumSQLS.KEY_GET_Employee}
              />
            </Grid>
          </Grid>
        }

        {Record.mtTaskTotalApprovers >= 3 &&
          <Grid container>
            <Grid item xs={12}>
              <MyAutoSuggest
                Id="mtnApproverID3"
                Record={Record}
                PlaceHolder={Record.mtnApproverCaption3}
                HandleChange={handleChange}
                ValidationMessages={Record.ValidationMessages}
                Required={true}
                SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
                SQLGetRecord={enumSQLS.KEY_GET_Employee}
              />
            </Grid>
          </Grid>
        }

        {Record.mtTaskTotalApprovers == 4 &&
          <Grid container>
            <Grid item xs={12}>
              <MyAutoSuggest
                Id="mtnApproverID4"
                Record={Record}
                PlaceHolder={Record.mtnApproverCaption4}
                HandleChange={handleChange}
                ValidationMessages={Record.ValidationMessages}
                Required={true}
                SQLGetList={enumSQLS.KEY_LIST_EmployeeSearch}
                SQLGetRecord={enumSQLS.KEY_GET_Employee}
              />
            </Grid>
          </Grid>
        }


      </Grid>
      }

      <Grid container padding={1}>
        <Grid item xs={6} align="left">
          <Button
            name="btnSubmit"
            variant="contained"
            sx={{ mr: 1 }}
            color="warning"
            size="small"
            disabled={MessageData.Loading || Record.IsLocked}
            onClick={() => submitData()}
          >
            Submit
          </Button>
        </Grid>

        <Grid item xs={6} align="right" >
          <Button
            name="btnSave"
            variant="contained"
            sx={{ mr: 1 }}
            color="success"
            size="small"
            disabled={MessageData.Loading || Record.IsLocked}
            onClick={() => saveData()}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Typography>
  );
}

